import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { PaymentType } from 'ts/types/PaymentType'
import { formatter } from 'utils'
import CardTable from 'components/CardTable'
import { Boolean as BooleanCell } from 'components/ui'
import PaymentTypeAddPage from './PaymentTypeAddPage'

const columns: Column<PaymentType>[] = [
  {
    Header: 'ID',
    accessor: 'paymentTypeId'
  },
  {
    Header: 'Active',
    accessor: 'flActive',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Payment Type',
    accessor: 'name'
  },
  {
    Header: 'Deposits?',
    accessor: 'flUsedInDeposits',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Refunds?',
    accessor: 'flUsedInRefunds',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Last Modified',
    accessor: 'lastModified',
    Cell: ({ value }) => formatter.dateTime(value)
  },
  {
    Header: '',
    accessor: 'typeId',
    Cell: ''
  }
]

const PaymentTypePage = () => {
  const Url = GetUrls();
  
  return (
  <CardTable
    columns={columns}
    dataKey={Url.getPaymentType.toString()}
    url={Url.getPaymentType}
    modalChild={<PaymentTypeAddPage />}
  />
)}

export default PaymentTypePage
